// Pricing -- unified home for the three pricing tools that used to be three
// separate left-menu pages (Rate Card / Vendor Price Book / Pricing Overrides).
// The three underlying pages are unchanged and still self-contained; this page
// just presents them as tabs under one destination. The active tab is driven by
// ?tab= so deep-links and the old-route redirects (/settings/catalog,
// /vendor-pricing, /costs) land on the correct tab.
import { useSearchParams } from 'react-router-dom';
import CostCatalogPage from './CostCatalogPage';
import VendorPricingPage from './VendorPricingPage';
import CostsPage from './CostsPage';

type TabKey = 'catalog' | 'vendors' | 'overrides';

const TABS: { key: TabKey; label: string; sub: string }[] = [
  { key: 'catalog',   label: 'Rate Card',         sub: 'Your standard unit costs' },
  { key: 'vendors',   label: 'Vendor Prices',     sub: 'Supplier quotes & benchmarks' },
  { key: 'overrides', label: 'Project Overrides', sub: 'Budget vs. current market' },
];

export default function PricingPage() {
  const [sp, setSp] = useSearchParams();
  const raw = sp.get('tab');
  const active: TabKey = (TABS.some(t => t.key === raw) ? raw : 'catalog') as TabKey;

  const setTab = (k: TabKey) => {
    const next = new URLSearchParams(sp);
    next.set('tab', k);
    setSp(next);
  };

  return (
    <div>
      <div style={{ padding: '18px 24px 0' }}>
        <div style={{
          fontSize: 11, fontWeight: 700, letterSpacing: 0.6,
          textTransform: 'uppercase', color: '#64748b', marginBottom: 8,
        }}>Pricing</div>
        <div style={{
          display: 'flex', gap: 4,
          borderBottom: '1px solid var(--border,#e2e8f0)',
        }}>
          {TABS.map(t => {
            const on = t.key === active;
            return (
              <button
                key={t.key}
                onClick={() => setTab(t.key)}
                title={t.sub}
                style={{
                  padding: '9px 16px',
                  border: 'none',
                  borderBottom: on ? '2px solid #0f172a' : '2px solid transparent',
                  background: 'transparent',
                  color: on ? '#0f172a' : '#64748b',
                  fontSize: 14,
                  fontWeight: on ? 700 : 600,
                  cursor: 'pointer',
                  marginBottom: -1,
                }}
              >
                {t.label}
              </button>
            );
          })}
        </div>
      </div>

      {active === 'catalog'   && <CostCatalogPage />}
      {active === 'vendors'   && <VendorPricingPage />}
      {active === 'overrides' && <CostsPage />}
    </div>
  );
}
